import {
  Http
} from '@/model/Http.js'

export default class withdraw extends Http {
  // 最近一次提现记录
  getWithdrawInfo(data){
    const url = 'api/open/platform-withdraw/get'
    return this.postAjaxByKfc(url, {
      ...data
    })
  }
  //提现记录
  getWithdrawList(data) {
    const url = 'api/open/platform-withdraw/search'
    return this.postAjaxByKfc(url, {
      ...data
    })
  }

  //提现申请
  insertWithdrawRecord(data) {
    const url = 'api/open/platform-withdraw/withdraw'
    return this.postAjaxByKfc(url, {
      ...data
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/kfc/withdraw.js